export default {
  oapi_getVcode4Login: {
    type: 'formDataPost'
  },
  oapi_login: {
    type: 'formDataPost'
  },
  tencentCloud_captchaCheckTest: {
    type: 'post'
  },
  // 忘记密码
  oapi_getVcodeByPhone:{
    type:'formDataPost'
  },
  oapi_resetPwd:{
    type:'formDataPost'
  }
}



// WEBPACK FOOTER //
// ./src/service/modules/login.js